import React from "react";
import { __ } from '@wordpress/i18n';
import NextStepLink from '../../../../components/util/next-step-link/index';
import { initialState } from '../../../../store/reducer';
import setSiteLogo from '../../../../components/media-uploader/utils';

const BusinessLogoActions = (props) => {
	const { onNextClick, customizeStep } = props;

	return (
		<>
			<NextStepLink ml1 customizeStep={customizeStep}
				onClick={(event) => {
					onNextClick();
				}}
				after
			>
				{__('Maybe Later', 'astra-sites')}
			</NextStepLink>
		</>
	);
};

export default BusinessLogoActions;
